<template>
  <div :class="{
      page: true,
      'page-devices': true,
      content: true,
      'page--overlayed': showContentOverlay('pageHome'),
    }">
    <IconSpinner v-if="!metersLoaded || !meter" :extra-classes="['page-devices__spinner']" />
    <MeterDetail v-else :meter="meter" />
  </div>
</template>

<script>
import IconSpinner from '@/components/icons/Spinner.vue';
import MeterDetail from '@/components/meters/MeterDetail.vue';
import { useAppStore } from '@/stores/useAppStore';
import { usePage } from '@/composables/usePage';
import { computed, defineComponent } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'page-meter-detail',
  components: {
    MeterDetail,
    IconSpinner,
  },
  setup() {
    const route = useRoute();
    const appStore = useAppStore();
    const { showContentOverlay } = usePage(undefined, route);

    const meters = computed(() => {
      const info = appStore.customerInfo || {}
      let thirdPartyMeterConfig = []
      let inverterSettings = []

      try {
        thirdPartyMeterConfig = JSON.parse(info.thirdPartyMeterConfig || '[]')
      } catch (e) {
        console.error('Failed to parse thirdPartyMeterConfig:', e)
      }

      try {
        inverterSettings = JSON.parse(info.inverterSettings || '[]')
      } catch (e) {
        console.error('Failed to parse inverterSettings:', e)
      }

      if (
        Array.isArray(thirdPartyMeterConfig) &&
        Array.isArray(inverterSettings)
      ) {
        return [...thirdPartyMeterConfig, ...inverterSettings]
      } else if (Array.isArray(thirdPartyMeterConfig)) {
        return thirdPartyMeterConfig
      } else if (Array.isArray(inverterSettings)) {
        return inverterSettings
      } else {
        return []
      }
    })

    const meter = computed(() => {
      const info = appStore.customerInfo || {}
      const meterId = route.params.meterid
      let thirdPartyMeterConfig = []
      let inverterSettings = []

      if (String(meterId).trim() === '1') {
        const config = JSON.parse(info.thirdPartyMeterConfig || '{}')
        const name = config.deviceMetadata?.manufacturer || 'Unknown'
        return { ...config, name }
      }

      try {
        thirdPartyMeterConfig =
          typeof info.thirdPartyMeterConfig === 'string' &&
          info.thirdPartyMeterConfig.trim() !== ''
            ? JSON.parse(info.thirdPartyMeterConfig)
            : info.thirdPartyMeterConfig
      } catch (e) {
        console.error('Failed to parse thirdPartyMeterConfig:', e)
        thirdPartyMeterConfig = []
      }

      try {
        inverterSettings =
          typeof info.inverterSettings === 'string' &&
          info.inverterSettings.trim() !== ''
            ? JSON.parse(info.inverterSettings)
            : info.inverterSettings
      } catch (e) {
        console.error('Failed to parse inverterSettings:', e)
        inverterSettings = []
      }

      let raw = []
      if (
        Array.isArray(thirdPartyMeterConfig) &&
        Array.isArray(inverterSettings)
      ) {
        raw = [...thirdPartyMeterConfig, ...inverterSettings]
      } else if (Array.isArray(thirdPartyMeterConfig)) {
        raw = thirdPartyMeterConfig
      } else if (Array.isArray(inverterSettings)) {
        raw = inverterSettings
      }

      const id = String(meterId).trim()
      return raw.find((m) => {
        const a = String(m.settings?.inverterHost || '').trim()
        const b = String(m.inverterSettings?.inverterid || '').trim()
        const c = String(m.inverterSettings?.inverterHost || '').trim()
        return a === id || b === id || c === id
      }) || null
    })

    const metersLoaded = computed(() => meters.value.length > 0 || meter.value)

    return {
      meter,
      metersLoaded,
      showContentOverlay
    }
  },
})
</script>

<style lang="scss">
  .page-devices {
    &__spinner {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 2rem;
      height: 2rem;
      animation: spin 1.8s linear 0s infinite;
    }
  }
</style>
